import WithRender from "../../templates/base/inputCustomFormatInsert.html";
import { mapGetters, mapActions } from "vuex";
import { i18n } from "../../i18n.js";

export default WithRender({
  computed: {
    ...mapGetters(["getCustomFormatLimits", "getActiveProductPageOptions"]),
    showCustomFormat: function () {
      if (
        this.getActiveProductPageOptions &&
        this.getActiveProductPageOptions["format"]
      ) {
        if (this.getActiveProductPageOptions["format"].values.length < 2) {
          return false;
        }
      }
      return true;
    }
  },
  methods: {
    ...mapActions(["setCustomFormat"]),
    onEnter: function (event) {
      event.preventDefault();
    },
    onClickInputCustomFormat: function (event) {
      this.$store.dispatch("inputCustomFormat", {
        width: this.width,
        height: this.height,
        widget: this
      });
    } /*
    validateInput(value, label, min, max) {
      value = value.replace(",", ".");
      if (value == "") {
        return { valid: false, msg: i18n.t("Please input " + label + "!") };
      }
      if (isNaN(value)) {
        return { valid: false, msg: i18n.t(label + " must be a number!") };
      }
      if (parseFloat(value) < min) {
        return {
          valid: false,
          msg: i18n.t("Width must be greater than") + " " + min
        };
      }
      if (parseFloat(value) > max) {
        return {
          valid: false,
          msg: i18n.t(label + " must be smaller than") + " " + max
        };
      }
      return { valid: true, msg: "", number: parseFloat(value) };
    }*/
  },
  data: function () {
    return {
      width: "",
      height: ""
    };
  },
  props: ["showFormats"]
});
